import * as m from "~/paraglide/messages.js";
import type { ServicePage } from "./types";

export function getRagPage(): ServicePage {
  return {
    art: {
      body: m.svc_rag_art_body(),
      foot: m.svc_rag_art_foot(),
      heading: m.svc_rag_art_heading(),
      kind: "sample-document",
      source: { icon: "googledrive", label: m.svc_rag_art_source() },
    },
    artNote: m.svc_rag_art_note(),
    capabilityId: "save-time",
    cta: { lede: m.svc_rag_cta_lede(), title: m.svc_rag_cta_title() },
    faq: [
      {
        answer: m.svc_rag_faq_1_answer(),
        question: m.svc_rag_faq_1_question(),
      },
      {
        answer: m.svc_rag_faq_2_answer(),
        question: m.svc_rag_faq_2_question(),
      },
      {
        answer: m.svc_rag_faq_3_answer(),
        question: m.svc_rag_faq_3_question(),
      },
      {
        answer: m.svc_rag_faq_4_answer(),
        question: m.svc_rag_faq_4_question(),
      },
    ],
    intro: m.svc_rag_intro(),
    keywords:
      "RAG development company, RAG development services, custom RAG system, AI knowledge base development, internal AI assistant, custom AI chatbot development, AI customer support automation, RAG izstrāde, AI zināšanu bāze",
    label: m.svc_rag_label(),
    limits: {
      body: m.svc_rag_limits_body(),
      items: [
        {
          term: m.svc_rag_limit_1_term(),
          value: m.svc_rag_limit_1_value(),
        },
        {
          term: m.svc_rag_limit_2_term(),
          value: m.svc_rag_limit_2_value(),
        },
        {
          term: m.svc_rag_limit_3_term(),
          value: m.svc_rag_limit_3_value(),
        },
      ],
      title: m.svc_rag_limits_title(),
    },
    meta: {
      description: m.svc_rag_meta_description(),
      title: m.svc_rag_meta_title(),
    },
    nav: m.svc_rag_nav(),
    scope: {
      body: m.svc_rag_scope_body(),
      points: [
        m.svc_rag_scope_point_1(),
        m.svc_rag_scope_point_2(),
        m.svc_rag_scope_point_3(),
        m.svc_rag_scope_point_4(),
      ],
      title: m.svc_rag_scope_title(),
    },
    serviceType: "RAG development and AI knowledge base development",
    slug: "rag-development",
    steps: {
      body: m.svc_rag_steps_body(),
      items: [
        m.svc_rag_step_1(),
        m.svc_rag_step_2(),
        m.svc_rag_step_3(),
        m.svc_rag_step_4(),
      ],
      title: m.svc_rag_steps_title(),
    },
    title: [m.svc_rag_title_1(), m.svc_rag_title_2()],
    uses: [
      {
        term: m.svc_rag_use_1_term(),
        value: m.svc_rag_use_1_value(),
      },
      {
        term: m.svc_rag_use_2_term(),
        value: m.svc_rag_use_2_value(),
      },
      {
        term: m.svc_rag_use_3_term(),
        value: m.svc_rag_use_3_value(),
      },
      {
        term: m.svc_rag_use_4_term(),
        value: m.svc_rag_use_4_value(),
      },
    ],
  };
}
